(function () {
  function init(section) {
    if (!section || section.dataset.coverCallingLolaReady === 'true') return;
    section.dataset.coverCallingLolaReady = 'true';
    initFigure(section);
    initBackdropFit(section);
  }

  // Same lazy-loading pattern as contact-lola/banner-lola: the day/night
  // figure images sit inertly in <template> tags and only the one matching
  // the current theme is cloned into the DOM, so a single image downloads.
  // A MutationObserver swaps it live when the visitor toggles day/night.
  function initFigure(section) {
    var container = section.querySelector('[data-cover-calling-lola-figure]');
    if (!container) return;

    var dayTemplate = container.querySelector('template[data-cover-calling-lola-figure-theme="day"]');
    var nightTemplate = container.querySelector('template[data-cover-calling-lola-figure-theme="night"]');
    if (!dayTemplate) return;

    var liveEl = null;
    var lastKey = null;

    function currentKey() {
      var isNight = document.documentElement.getAttribute('data-theme') === 'night';
      return isNight && nightTemplate ? 'night' : 'day';
    }

    function render() {
      var key = currentKey();
      if (key === lastKey) return;

      var template = key === 'night' ? nightTemplate : dayTemplate;
      if (liveEl) liveEl.remove();

      var wrapper = document.createElement('div');
      wrapper.style.display = 'contents';
      wrapper.appendChild(template.content.cloneNode(true));
      container.appendChild(wrapper);

      liveEl = wrapper;
      lastKey = key;
    }

    new MutationObserver(render).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    render();
  }

  // Fits the oversized backdrop word exactly to the available width, so
  // translated words of different lengths (MAGAZIN, MAGAZINE, RIVISTA...)
  // always span the cover without overflowing. Exposes the resulting size
  // as --ccl-backdrop-size, used by the mobile layout to overlap the figure.
  function initBackdropFit(section) {
    var backdrop = section.querySelector('[data-cover-calling-lola-backdrop]');
    var word = section.querySelector('[data-cover-calling-lola-backdrop-word]');
    if (!backdrop || !word) return;

    var MAX_SIZE = 460;
    var frame = null;

    function fit() {
      frame = null;
      var available = backdrop.clientWidth;
      if (!available) return;

      // Measure the word itself (an inline-block span), not the full-width
      // paragraph, so short words scale up as well as long words down.
      backdrop.style.fontSize = '100px';
      var measured = word.offsetWidth;
      if (!measured) return;

      var size = Math.min(MAX_SIZE, Math.floor((100 * available) / measured));
      backdrop.style.fontSize = size + 'px';
      section.style.setProperty('--ccl-backdrop-size', size + 'px');
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(fit);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(section);
    } else {
      window.addEventListener('resize', schedule);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }

    schedule();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-cover-calling-lola]').forEach(init);
  }

  initAll();

  // Theme Editor: re-initialise when the section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
